<template>
    <q-footer>
        <div class="footer-wrap">
            <div class="row">
                <div class="logo col-12 col-md-1">
                    <router-link to="/">
                        <img alt="CMFA logo" src="@/assets/logo.svg" />
                    </router-link>
                </div>
                <div class="sitemap partner-links col-12 col-sm-grow">
                    <h6 class="capitalize-text">
                        {{ $tc('general.partners', 2) }}
                    </h6>
                    <ul>
                        <li v-for="(partner, index) in partners" :key="index">
                            <router-link :to="'/partners/' + partner.id">
                                {{
                                    JSONParseTranslations(
                                        partner.title,
                                        locale.key
                                    )
                                }}
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="sitemap partner-links col-12 col-sm-grow">
                    <h6>CFMA</h6>
                    <ul>
                        <li v-for="(link, index) in legalLinks" :key="index">
                            <router-link :to="link.slug">
                                {{ link.title }}
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="sitemap partner-links col-12 col-sm-grow">
                    <h6 class="capitalize-text">{{ $t('general.support') }}</h6>
                    <ul>
                        <li v-for="(link, index) in supportLinks" :key="index">
                            <router-link :to="link.slug">
                                {{ link.title }}
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div
                    v-if="!user"
                    class="login-wrap col-12 col-sm-grow col-md-shrink"
                >
                    <router-link
                        :to="{
                            name: 'Login',
                            query: { redirect: $route.path },
                        }"
                        class="login"
                    >
                        {{ $t('actions.login') }}
                    </router-link>
                    <router-link to="/sign-up" class="sign-up">
                        {{ $t('actions.signup') }}
                    </router-link>
                </div>
                <div class="social-links row col-12 col-lg-grow text-right">
                    <div class="social-icons col-12 col-sm-6 col-md-grow">
                        <a
                            href="https://facebook.com/cfmaangola/"
                            class="q-ml-lg"
                            target="_blank"
                        >
                            <q-icon
                                class="q-my-sm"
                                color="white"
                                size="32px"
                                name="eva-facebook"
                            ></q-icon>
                        </a>
                        <!-- <a
                            class="q-ml-lg"
                            href="https://twitter.com/cfmaangola"
                            target="_blank"
                        >
                            <q-icon
                                class="q-my-sm"
                                color="white"
                                size="32px"
                                name="eva-twitter"
                            ></q-icon>
                        </a> -->
                        <a
                            class="q-ml-lg"
                            href="https://www.linkedin.com/company/cfma-centro-de-forma%C3%A7%C3%A3o-mar%C3%ADtima-de-angola/"
                            target="_blank"
                        >
                            <q-icon
                                class="q-my-sm"
                                color="white"
                                size="32px"
                                name="eva-linkedin"
                            ></q-icon>
                        </a>
                        <a
                            class="q-ml-lg"
                            href="https://www.instagram.com/cfma_angola/"
                            target="_blank"
                        >
                            <q-icon
                                class="q-my-sm bi bi-instagram"
                                color="white"
                                size="32px"
                                name="fab fa-instagram"
                            ></q-icon>
                        </a>
                    </div>
                    <span class="self-end col-12 col-sm-6 col-md-grow q-my-md">
                        {{ `© ${new Date().getFullYear()} CFMA.` }}
                        {{ $t('general.all_rights_reserved') }}
                    </span>
                </div>
            </div>
        </div>
    </q-footer>
</template>

<script>
import store from '@/store'
import partnersService from '@/services/modules/partners'
import translate from '@/local-shared/mixins/translate'

const loadingKeys = {
    fetchingPartners: 'fetching-partners',
}

export default {
    name: 'Footer',

    mixins: [translate],

    data() {
        return {
            partners: [],
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingPartners
        },

        isFetchingPartners() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingPartners
            ).length
        },

        user() {
            return store.getters['session/user']
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        legalLinks() {
            return [
                {
                    title: this.$t('footers.service_terms'),
                    slug: '/terms-and-services',
                },
                {
                    title: this.$t('footers.privacy_policy'),
                    slug: '/privacy-policy',
                },
                {
                    title: this.$t('footers.site_map'),
                    slug: '/sitemap',
                },
            ]
        },

        supportLinks() {
            return [
                {
                    title: this.$t('footers.contact'),
                    slug: '/contact',
                },
            ]
        },
    },

    async created() {
        await this.fetchPartners()
    },

    methods: {
        async fetchPartners() {
            this.loadingAdd(loadingKeys.fetchingPartners)

            let parameters = {
                filter: {
                    active: true,
                    on_partners_page: true,
                },
                orderBy: [
                    {
                        column: 'title',
                        direction: 'asc',
                    },
                ],
            }

            let response = await partnersService.partners.retrieve(parameters)

            if (response.status === 200) {
                this.partners = response.data.results
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingPartners)
        },
    },
}
</script>
